import { Box, styled, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  Button,
  Space,
  Table,
  Tag,
  Input,
  Select,
  Modal,
  DatePicker,
} from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useAxios } from "../../contexts/AxiosProvider";
import { EngagementApi } from "../../services/EngagementApi";
import { useSnackbar } from "notistack";
import AddEngagement from "./AddEngagement";
import { ClientApi } from "../../services/ClientApi";
import { VscDebugStart, VscRunAll } from "react-icons/vsc";
import { getEnvironmentConfig } from "../../constants/CloudConstant";
import { LoadingButton } from "@mui/lab";
import { parseISO } from "date-fns";
import UtcMinusFour from "../../utils/UtcMinusFour";

const { Search } = Input;

const EngagementContainer = styled(Box)(({ openDrawer, isDashboard }) => ({
  marginLeft: openDrawer ? 240 : isDashboard ? 0 : 80,
  width: openDrawer
    ? "calc(100% - 255px)"
    : isDashboard
    ? "calc(100% - 5px)"
    : "calc(100% - 85px)",
  // backgroundColor: "#f8f8ff",
  // border: openDrawer ? "2px solid green" : "2px solid blue",
  height: "calc(100vh - 70px)",
}));

const SearchAndFilter = styled(Box)(() => ({
  display: "flex",
  margin: "20px 20px",
  flexDirection: "row",
  justifyContent: "space-between",
}));

const Engagement = ({ openDrawer, userData, engagementData }) => {
  const axios = useAxios();
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [engagements, setEngagements] = useState({
    engagementList: [],
    totalEngagements: 0,
  });
  const [selectedClient, setSelectedClient] = useState("");
  const [engagementName, setEngagementName] = useState("");
  const [clientData, setClientData] = useState({
    clientList: [],
    totalDomains: 0,
  });

  const [isRunDatePickerOpen, setIsRunDatePickerOpen] = useState(false);
  const [datePicked, setDatePicked] = useState("");
  const [currentEngagement, setcurrentEngagement] = useState({});
  const [status, setStatus] = useState("");
  const [loading, setloading] = useState(false);

  const [pagination, setpagiNation] = useState({ pageSize: 10, pageNo: 1 });

  const handlePagination = (page, pageSize) => {
    setpagiNation({ ...pagination, pageNo: page, pageSize: pageSize });
  };

  const [isAddEngagementModalOpen, setIsAddEngagementModalOpen] =
    useState(false);
  const showAddEngagementModal = () => {
    setIsAddEngagementModalOpen(true);
  };

  const openDatePickerModal = (record) => {
    setcurrentEngagement(record);
    setloading(false);
    setDatePicked("");
    setIsRunDatePickerOpen(true);
  };
  const handleDateCancel = () => {
    setDatePicked("");
    setIsRunDatePickerOpen(false);
  };
  const onDateChange = (date, dateString) => {
    setDatePicked(dateString);
  };

  const handleCloseModal = () => {
    setIsAddEngagementModalOpen(false);
  };

  const handleCancel = () => {
    setEngagementName("");
    setSelectedClient("");
    setClientData({ clientList: [], totalDomains: 0 });
    setIsAddEngagementModalOpen(false);
  };

  const fetchAllEngagements = async (
    pageNo = pagination.pageNo,
    pageSize = pagination.pageSize,
    status = ""
  ) => {
    try {
      setloading(true);
      const data = {
        user_id: location.state.userId,
        client: engagementData.client_id !== "all-engagements",
        client_id:
          engagementData.client_id !== "all-engagements"
            ? engagementData.client_id
            : "",
        search: false,
        searchParam: "",
        pageNumber: pageNo,
        pageSize: pageSize,
        status: status,
      };
      const response = await EngagementApi.getAllEngagements(axios, data);
      if (response.status === 200) {
        setEngagements(response.data);
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } finally {
      setloading(false);
    }
  };
  useEffect(() => {
    fetchAllEngagements(pagination.pageNumber, pagination.pageSize, status);
  }, [status]);

  const showDeleteConfirm = (record) => {
    Modal.confirm({
      title: "Are you sure you want to delete this Pipeline?",
      content: "This action cannot be undone.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: () => deleteEngagement(record),
    });
  };

  const deleteEngagement = async (record) => {
    try {
      const response = await EngagementApi.deleteEngagement(
        axios,
        record.engagement_id
      );
      if (response.status === 200) {
        enqueueSnackbar("Pipeline Deleted", {
          variant: "success",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
        fetchAllEngagements();
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    }
  };

  const executeEngagementRun = async (datePicked) => {
    try {
      const engagementRunRequest = {
        engagement_id: currentEngagement.engagement_id,
        userId: userData.userId,
        username: userData.username,
        cloudEnvironment: getEnvironmentConfig().cloudEnvironment,
        workflow_run_date: datePicked,
      };

      const res = await EngagementApi.executeEngagementProcessorApi(
        axios,
        engagementRunRequest
      );
      if (res.status === 200) {
        enqueueSnackbar(`Pipeline Running !!`, {
          variant: "success",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } catch (error) {
      enqueueSnackbar(`Something went wrong`, {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
    } finally {
      setIsRunDatePickerOpen(false);
      setDatePicked("");
    }
  };

  const RenderWorkflowComponent = (record) => {
    navigate(`/dep/workflow/${record.engagement_id}/data-all`, {
      state: {
        ...userData,
      },
    });
  };

  const EngagementColumns = [
    {
      title: "Function Name",
      dataIndex: "domain_name",
      key: "domain_name",
    },
    {
      title: "Sub-Function Name",
      dataIndex: "client_name",
      key: "client_name",
    },
    {
      title: "Pipeline Name",
      dataIndex: "engagement_name",
      key: "engagement_name",
      onCell: (record) => {
        return {
          onClick: () => {
            RenderWorkflowComponent(record); // Call openDrawer function here or pass any necessary data to Engagement component
          },
        };
      },
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Asset Tag",
      dataIndex: "asset_tag",
      key: "asset_tag",
    },
    {
      title: "Created By",
      dataIndex: "created_by",
      key: "created_by",
    },
    {
      title: "Creation Date",
      dataIndex: "created_at",
      key: "created_at",
      render: (text, record) => {
        const date = parseISO(record.created_at);
        const utcMinusFour = new UtcMinusFour(date);
        return (
          <Typography variant="body1" gutterBottom sx={{ color: "#00043C" }}>
            {utcMinusFour.formatUtcMinusFour()}
          </Typography>
        );
      },
    },
    {
      title: "Status",
      key: "status",
      width: 140,
      dataIndex: "status",
      filters: [
        {
          text: "approved",
          value: "approved",
        },
        {
          text: "rejected",
          value: "rejected",
        },
        {
          text: "pending",
          value: "pending",
        },
      ],
      filterMultiple: false,
      onFilter: (value, record) => record.status === value,
      render: (_, { status }) => (
        <>
          <Tag
            color={
              status === "approved"
                ? "green"
                : status === "pending"
                ? "yellow"
                : "red"
            }
            key={status}
          >
            {status}
          </Tag>
        </>
      ),
    },
    {
      title: "Run",
      key: "run",
      width: 60,
      onCell: (record) => {
        return {
          onClick: () => {
            if (!record.run_disabled) openDatePickerModal(record);
          },
        };
      },
      render: (_, { run_disabled }) => (
        <Space size="middle">
          <Button
            disabled={run_disabled}
            type="primary"
            shape="circle"
            icon={<VscDebugStart size={20} />}
          />
        </Space>
      ),
    },
    // {
    //   title: "Action",
    //   key: "action",
    //   onCell: (record) => {
    //     return {
    //       onClick: () => {
    //         showDeleteConfirm(record);
    //       },
    //     };
    //   },
    //   render: (_, record) => (
    //     <Space size="middle">
    //       <a>Delete</a>
    //     </Space>
    //   ),
    // },
  ];

  const handleTableChange = (pagination, filters) => {
    const currentStatus = filters.status ? filters.status[0] : "";
    setStatus(currentStatus);
    fetchAllEngagements(pagination.current, pagination.pageSize, currentStatus);
  };

  const onSearchEngagement = async (value, _e) => {
    try {
      setloading(true);
      const data = {
        user_id: location.state.userId,
        client: engagementData.client_id !== "all-engagements",
        client_id:
          engagementData.client_id !== "all-engagements"
            ? engagementData.client_id
            : "",
        search: true,
        searchParam: value,
        pageNumber: 0,
        pageSize: 0,
      };
      const response = await EngagementApi.getAllEngagements(axios, data);
      if (response.status === 200) {
        setEngagements(response.data);
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } finally {
      setloading(false);
    }
  };

  const onFilterClient = async (value, _e) => {
    try {
      setloading(true);
      const data = {
        user_id: location.state.userId,
        client: value === undefined ? false : true,
        client_id: value,
        search: false,
        searchParam: "",
      };
      const response = await EngagementApi.getAllEngagements(axios, data);
      if (response.status === 200) {
        setEngagements(response.data);
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } finally {
      setloading(false);
    }
  };

  return (
    <EngagementContainer
      openDrawer={openDrawer}
      isDashboard={engagementData.dashboard}
    >
      {engagementData.isSearchFilterVisible && (
        <SearchAndFilter>
          <Search
            placeholder="Search Pipeline"
            allowClear
            enterButton
            size="large"
            onSearch={onSearchEngagement}
            style={{ width: "20%" }}
          />
          <div style={{ display: "flex" }}>
            {/* <Select
              placeholder="Filter By Client"
              style={{ width: 200, marginRight: 5 }}
              size="large"
              allowClear
              onClear={onFilterClient}
              onSelect={onFilterClient}
              options={clientData.clientList
                ?.filter((item) => item.status === "approved")
                .map((item) => ({
                  value: item.client_id,
                  label: item.client_name,
                }))}
            /> */}
            <Button
              type="primary"
              size="large"
              onClick={showAddEngagementModal}
            >
              Add Pipeline
            </Button>
          </div>
        </SearchAndFilter>
      )}
      <div
        style={{
          width: "100%",
          maxHeight: "85%",
          overflowY: "auto",
        }}
      >
        <Table
          bordered
          loading={loading}
          columns={EngagementColumns}
          style={{ fontWeight: "640", margin: "20px 20px" }}
          sticky
          dataSource={engagements.engagementList}
          pagination={{
            total: engagements.totalEngagements,
            pageSize: pagination.pageSize,
            current: pagination.pageNo,
            onChange: handlePagination,
          }}
          onChange={handleTableChange}
        />
      </div>
      <Modal
        title="Add Pipeline"
        visible={isAddEngagementModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <AddEngagement
          userData={userData}
          setIsAddEngagementModalOpen={setIsAddEngagementModalOpen}
        />
      </Modal>

      <Modal
        centered
        footer={null}
        title={<div style={{ textAlign: "center" }}>Select Date</div>}
        width={400}
        open={isRunDatePickerOpen}
        onCancel={handleDateCancel}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <DatePicker
            format={{ format: "YYYY/MM/DD" }}
            onChange={onDateChange}
          />
          <LoadingButton
            size="large"
            type="submit"
            variant="outlined"
            loading={loading}
            sx={{
              marginTop: "10px",
              marginRight: "7px",
              backgroundColor: "#ffffff",
              "&:hover": { backgroundColor: "#ffffff" },
              color: "#00043C",
              border: "1px solid black",
            }}
            onClick={() => executeEngagementRun(datePicked)}
            disabled={datePicked === ""}
          >
            Run
          </LoadingButton>
        </div>
      </Modal>
    </EngagementContainer>
  );
};

export default Engagement;
